<template>
   <div class="cli">
      <ddoSelect2
         v-if="selectVisible"
         key="mainSwitchCustomer"
         :callbacks="callbacks"
         :options="options"
         ref="mySelect"
      >

         <template v-slot:selection="data">
          <v-chip
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            @click:close="close_item(data,data.item)"
          >
            <span v-text="data.item.cus_name"></span>
          </v-chip>
        </template>

        <template v-slot:item="data">
          <v-list-item-content>
            <v-list-item-title v-html="hiliteText(data.item.cus_name)"></v-list-item-title>
            <v-list-item-subtitle v-html="hiliteText(data.item.cus_code+' ('+data.item.cut_name+') '+' (k='+data.item.cus_pk+')')"></v-list-item-subtitle>
          </v-list-item-content>
        </template>

      </ddoSelect2>

      <v-switch
         v-if="option_itself"
         v-model="value_itself"
         @change="change_itself"
         :label="$t('texts.session_itself')"
      >
      </v-switch>

   </div> 
</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoSelect2 from '@/components/ddoSelect2.vue';

export default {
   name: 'ddoSelectSwitchCustomer',
   extends: ddoSelect2,
   components: {
      ddoSelect2
   },
   props: {
      callbacks: {
         type: Object,
         default: function () {
            return {
               search: null,
            }
         }
      },
      options: {
         type: Object,
         default: function () {
            return {
               initial: null,
               selected: null,
               multiple: false,
               clearable: false,
               item_text: "cus_name",
               item_value: "_pk",
               item_disabled: "",
               hide_selected: false,
               switch_myself: false,
               label: i18n.t('texts.switch_customer'),
            }
         }
      },
   },

   data: () => {
      return {
         selectVisible: true,
         option_itself: false,
         value_itself: false,
         current_session: null,
         refreshInProgress: false,
         lastSearch: '',
         SEARCH_MIN_LENGTH: 2,
      }
   },

   async created() {
      this.callbacks.refresh_rows = this.build_select_cus;
      this.callbacks.change = this.change;
      this.callbacks.filterMethod = this.CUSfilterMethod;
      this.options.search_refresh = true;
   },

   async mounted() {
      await this.get_session();
      await this.refresh_rows();
   },

   methods: {

      hiliteText(text) {
         if ( this.lastSearch!=null && this.lastSearch.length>0 ) {
            text = this.$api._hilite(text,this.lastSearch);
         }
         //console.log('this.lastSearch, text='+text+', lastSearch='+this.lastSearch)
         return text;
      },

      CUSfilterMethod(item, queryText, itemText) {
         var ret = itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
         if ( !ret && item.cus_code!=null ) {
            ret = item.cus_code.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
         }
         return ret;
      },

      async get_session() {
         var { errorinfos, api_response } = await this.$api._get_session(this.$router);
         if ( api_response.error==0 && api_response.row ) {
            this.current_session = api_response.row;
            this.value_itself = this.current_session.ses_itself;
            //this.options.initial = api_response.row.cus_pk_customer;
            this.options.selected = api_response.row.cus_pk_customer;
            if ( api_response.row.cut_is_reseller==true || api_response.row.cut_is_admin==true ) {
               //console.log('cus_pk is considered as ADMIN or RESELLER');
               this.selectVisible = true;
               this.option_itself = ( api_response.row.cus_pk==api_response.row.cus_pk_customer ? true : false );
            } else {
               //console.log('cus_pk is considered as PLAIN CUSTOMER');
               this.selectVisible = false;
               this.option_itself = false;
            }
         }
      },

      async refresh_rows(key=null,search=null) {
         //console.log('SwitchCustomerVue::refresh_rows, key='+key+', search='+search)
         this.refreshInProgress = true;
         if ( typeof this.callbacks.refresh_rows == 'function' ) {
            var { errorinfos, api_response } = await this.callbacks.refresh_rows(key,search);
         } else {
            var { errorinfos, api_response } = await this.build_select_cus(key,search);
         }
         this.refreshInProgress = false;
         if ( api_response && api_response.error==0 && api_response.rows ) {
            var raw_rows = api_response.rows;
         } else {
            var raw_rows = [];
         }
         this.items = raw_rows;
         this.refreshInProgress = false;
      },

      async build_select_cus(key=null,search=null) {
         this.lastSearch = search;
         //console.log('SwitchCustomerVue::build_select_cus, key='+key+', search='+search)
         if ( this.current_session==null ) {
            await this.get_session();
         }
         if ( this.current_session ) {
            this.loading = true;
            let old_search = sessionStorage.getItem("cus_search");
            if ( search!=null ) {
               sessionStorage.setItem("cus_search",search);
            }
            if ( search==null && old_search!= null ) {
               search = old_search;
            }
            let parameters = ( search!=null && search.length>this.SEARCH_MIN_LENGTH ? { cus_search: search } : null );
            //console.log('SwitchCustomerVue::build_select_cus, parameters='+JSON.stringify(parameters))
            //var { errorinfos, api_response } = await this.$api.getRows(this.$router,'customerreseller');
            var { errorinfos, api_response } = await this.$api.getRows(this.$router,'session'+'/'+this.current_session.ses_sessionid+'/customers',parameters);
            this.loading = false;
            return { errorinfos, api_response }
         } else {
            return null;
         }
      },

      async change_itself(value) {
         await this.change(this.current_session.cus_pk_customer);
      },

      async change(value) {
         var currentSession = sessionStorage.getItem("session");
         var { errorinfos, api_response } = await this.$api.updateRow(this.$router, 'session', currentSession,  {'cus_pk_customer': value, 'ses_itself': this.value_itself}, 'switch_customer');
         if ( api_response.error==0 && api_response.rows ) {
            await this.get_session();
         }
         this.$emit('switchCustomer',this.current_session);
      },

      async close_item(data,item) {
         this.$refs.mySelect.remove(item);
      },

   },

}
</script>